import { gql, useMutation, useQuery } from '@apollo/client';

export type Schema = {
  id: string;
  name: string;
  schema: string;
  description?: string;
  createdAt?: Date;
  lastUpdatedAt?: Date;
};

export type Apis = {
  edges: Node[];
  __typename: string;
};

type Node = {
  node: {
    id: string;
    name: string;
  };
};

export const GET_SCHEMA_QUERY = gql`
  query GetSchema($accountId: String!) {
    Schema(id: $accountId) {
      name
      description
      schema
      createdAt
    }
  }
`;

export const useDynamicSchema = (accountId: string) => {
  return useQuery<{ Schema: Schema }>(GET_SCHEMA_QUERY, {
    variables: { accountId },
  });
};

export const useGetAllAPINames = () => {
  return useQuery<{ Apis: Apis }>(
    gql`
      query GetApi {
        Apis(input: {}) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    `,
  );
};

export const useCreateSchema = accountId => {
  return useMutation(
    gql`
      mutation CreateSchemaMutation($schema: CreateSchemaInput!) {
        CreateSchema(input: $schema) {
          schema
          name
          description
          createdAt
        }
      }
    `,
  );
};

export const useUpdateSchema = accountId => {
  return useMutation(
    gql`
      mutation CreateSchemaMutation($schema: CreateSchemaInput!) {
        CreateSchema(input: $schema) {
          schema
          name
          description
          createdAt
        }
      }
    `,
    {
      update(cache, { data }) {
        try {
          const createdSchema = data?.CreateSchema;
          if (createdSchema) {
            cache.writeQuery({
              query: GET_SCHEMA_QUERY,
              variables: { accountId },
              data: {
                Schema: createdSchema,
              },
            });
          }
        } catch (error) {
          console.log('Failed to update schema object into local cache', { error });
        }
      },
    },
  );
};
